<template>
    <VDialog v-model="visivel" scrollable>
        <VCard>
            <Loading ref="loading"></Loading>
            <VCardTitle>Comanda - {{idComandaDetalhe}} - {{(ComandaDetalheLida == null ? "" : (ComandaDetalheLida.cliente == null ? "" : ComandaDetalheLida.cliente.nome))}} - {{(ComandaDetalheLida == null ? "" : formatarData(ComandaDetalheLida.data))}}</VCardTitle>
            <VCardText>
                <VDataTable :headers="cabecalhosEventos" :items="listaServicos" item-key="nome"  :pagination.sync="paginacao">
                    <template #items="props">
                        <tr>
                            <td>{{props.item.servico.nome}}</td>
                            <td>{{formatarHora(props.item.hora)}}</td>
                            <td>{{props.item.situacao}}</td>
                            <td>{{props.item.espaco.nome}}</td>
                            <td>{{props.item.profissionais.responsavel.nome}}</td>
                            <td>{{formatarDinheiro(props.item.valorBruto)}}</td>
                        </tr>
                    </template>
                </VDataTable>
                <VDataTable v-if="listaProdutos" :headers="cabecalhosProdutos" :items="listaProdutos" item-key="nome"  :pagination.sync="paginacao">
                    <template #items="props">
                        <tr>
                            <td>{{props.item.nome}}</td>
                            <td>{{props.item.profissional.nome}}</td>
                            <td>{{props.item.quantidade}}</td>
                            <td>{{formatarDinheiro(props.item.valorBruto)}}</td>
                        </tr>
                    </template>
                </VDataTable>
            </VCardText>
            <VCardActions>
                <VLayout justify-end>
                    <VBtn color="primary" @click="visivel = false">Fechar</VBtn>
                </VLayout>
            </VCardActions>
        </VCard>
    </VDialog>
</template>

<script>
    import Loading from "./Loading";
    import ApiService from "../../common/api.service";
    import alerts from "../../common/alerts";
    import datas from "../../mixins/datas";
    import numeros from "../../mixins/numeros";
    import moment from "moment"

    export default {
        mixins: [datas, numeros],
        methods: {
            formatarHora(dataHora) {
                const momentHora = moment(dataHora, undefined, true);
                if (!momentHora.isValid()) {
                    return dataHora;
                }
                return momentHora.format("DD/MM/YYYY HH:mm"); //momentHora.format('LT');
            } //,
           // mostraItensComanda(idComandaSelecionada) {
                //console.log(idComandaSelecionada);
           // }
        },
        data() {
            return {
                visivel: false,
                ComandaDetalheLida: null,
                nomeCliente: "",
                paginacao: {
                    page: 1,
                    rowsPerPage: 4,
                    sortBy: 'nome',
                    descending: false
                },
                cabecalhosEventos: [
                           //servico.nome
                           //hora
                           //situacao
                           //espaco.nome
                           //profissionais.responsavel.nome
                           //valorBruto
                    {
                        text: "Serviço",
                        value: "servico.nome"
                    },
                    {
                        text: "Agendamento",
                        value: "hora"
                    },
                    {
                        text: "Situação",
                        value: "situacao"
                    },
                    {
                        text: "Espaço",
                        value: "espaco.nome"
                    },
                    {
                        text: "Profissional",
                        value: "profissionais.responsavel.nome"
                    },
                    {
                        text: "Valor",
                        value: "valorBruto"
                    }
                ],
                cabecalhosProdutos: [
                           //nome
                           //profissional.nome
                           //quantidade
                           //valorBruto
                    {
                        text: "Produto",
                        value: "nome"
                    },
                    {
                        text: "Profissional",
                        value: "profissional.nome"
                    },
                    {
                        text: "Quantidade",
                        value: "quantidade"
                    },
                    {
                        text: "Valor",
                        value: "valorBruto"
                    }
                ]
            }
        },
        computed: {
            /*funcaoexterna(idParam){
                const respostas = await this.enviarEAguardarBackend([ApiService.getComanda(idParam)]);
                this.comandaLida = respostas[0].data;
                return this.comandaLida.id;
            },*/
            listaServicos() {
                return (this.ComandaDetalheLida == null ? [] : this.ComandaDetalheLida.eventos);
            },
            listaProdutos() {
                return (this.ComandaDetalheLida == null ? [] : this.ComandaDetalheLida.produtos);
            },
            listaAbertas() {
                return 1;
                //rever
                //console.log(this.listaComandasAbertas);
                //this.listaComandasAbertas.forEach(e => e.valorServicos = funcaoexterna(e.id));
         //       return this.ComandaDetalheLida.map(e => {
         //           console.log(e);
         //           e.idNumeroManual = `${e.idNumeroManual !== null ? e.idNumeroManual : e.id}`;
         //           return e;
         //       });


                        //eventos
                           //servico.nome
                           //hora
                           //situacao
                           //espaco.nome
                           //profissionais.responsavel.nome
                           //valorBruto
                        //produtos
                           //nome
                           //profissional.nome
                           //quantidade
                           //valorBruto

                        //listar
//Serviços / Produtos
//Espaço
//Profissionais
//Valor de cada serviço / Produto agendado

            }
        },
        props: {
            value: Boolean,
            idComandaDetalhe: Number,
            ocultar: Boolean
        },
        components: {
            Loading
        },
        watch: {
            async visivel(v) {
                if (v) {
                    try {
                        [this.ComandaDetalheLida] = (await this.$refs.loading.aguardarPromises([ApiService.get(`comandas/${this.idComandaDetalhe}`)])).map(r => r.data);
                    } catch (e) {
                        alerts.exibirErro('Não foi possível carregar as comandas abertas', e);
                        this.visivel = false;
                        return;
                    }
                } else {
                    this.ComandaDetalheLida = [];
                }
                if (v !== this.value) {
                    this.$emit('input', v);
                }
            },
            value(v) {
                this.visivel = v;
            }
        }
    }
</script>

<style scoped>

</style>
